import { defineComponent as o, openBlock as n, createElementBlock as r, renderSlot as t } from "vue";
const a = { class: "rounded-lg bg-white drop-shadow-lg" }, d = /* @__PURE__ */ o({
  __name: "PaperContainer",
  setup(s) {
    return (e, p) => (n(), r("div", a, [
      t(e.$slots, "default")
    ]));
  }
});
export {
  d as PaperContainer
};
//# sourceMappingURL=index.es.js.map
